<template>
  <div class="add-new-account-pop-up">
    <vs-popup @cancel="clearAccountForm" :active.sync="showPopup">
      <div class="create-new-account-parent">
        <h2 class="create-new-account-title">{{$t('Add New Account')}}</h2>

        <div class="vx-row">
          <div class="vx-col w-full account-type-parent">
            <label class="account-name-label" for="">{{$t('Account Name')}}</label>
            <p class="account-name-desc">{{$t('The account name must be unique')}}</p>
            <input
              id="add-new-account-name-input"
              maxLength="35"
              v-validate="`required|min:6|max:35`"
              data-vv-validate-on="input|keyup|blur"
              name="name"
              placeholder="Account Name"
              v-model="accountForm.name"
              class="account-name-input w-full"/>
            <span class="text-danger text-sm block">{{ errors.first('name') }}</span>
            <span v-if="errors.has('nameExist')" class="text-danger text-sm block">{{ errors.first('nameExist')}}</span>
          </div>
        </div>

        <div class="vx-row account-country-parent">
          <div class="vx-col w-full">
            <label class="account-country-label" for="">{{$t('Account Country')}}</label>
            <speakol-select
              id="add-new-account-country-list"
              class="w-full account-country-dropdown"
              displayLabel="name"
              placeholder="Select Country"
              v-model="accountForm.country"
              v-validate="'required'"
              name="country"
              index="id"
              :options="countries"
            >
            </speakol-select>
            <span class="text-danger text-sm block">{{ errors.first('country') }}</span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="account-type-label">{{$t('Account Type')}}</label>
            <v-select
              id="add-new-account-type-list"
              :options="accountTypes"
              label="text"
              v-validate="'required'"
              data-vv-validate-on="input|keyup|blur"
              name="account type"
              placeholder="Account Type"
              v-model="accountForm.typeObj"
              class="w-full account-type-dropdown">
            </v-select>
            <span class="text-danger text-sm block">{{ errors.first('account type') }}</span>
          </div>
        </div>

        <div class="vx-row" v-if="accountForm.typeObj && accountForm.typeObj.value === 'company'">
          <div class="vx-col w-full company-name-parent">
            <label class="company-name-label" for="">{{$t('Company Name')}}</label>
            <input
              id="add-new-account-company-name-input"
              data-vv-name="company name"
              icon-no-border
              maxLength="40"
              v-validate="'required|min:5|max:40'"
              data-vv-validate-on="input|keyup|blur"
              name="company_name"
              placeholder="Company Name"
              v-model="accountForm.company_name"
              class="company-name-input w-full"/>
            <span class="text-danger text-sm block">{{ errors.first('company name') }}</span>
          </div>
        </div>

        <div class="actions-parent text-right">
          <button id="add-new-account-cancel-button" class="mr-4 add-new-account-cancel-button" v-on:click="clearAccountForm">Cancel</button>
          <button id="add-new-account-add-button" class="add-new-account-add-button" @click="createAccount">Add</button>
        </div>
      </div>
    </vs-popup>

    <vs-popup :active.sync="successPrompt" class="text-center">
      <img src="@/assets/images/pages/settings/loading.svg"/>
      <p class="mb-5">Account has been created Successfully.</p>
      <vs-button class="w-1/2" size="medium" @click="hidePopup">Ok</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import {isEmpty} from 'lodash'

export default {
  name: 'CreateAccount',
  props: {
    show: {
      required: true,
      default: false
    }
  },
  data () {
    return {
      successPrompt: false,
      accountForm: {
        typeObj: null,
        name: '',
        company_name: '',
        country: null
      },
      accountTypes: [
        {
          value: 'individual',
          text: 'Individual'
        },
        {
          value: 'company',
          text: 'Company'
        }
      ],
      countries: []
    }
  },
  mounted () {
    this.getCountries()
  },
  computed: {
    showPopup: {
      get () {
        return this.show
      },
      set (newValue) {
        this.$emit('show', newValue)
      }
    },
    personalAccountNames () {
      return this.$store.getters['authentication/accounts'].filter(account => account.type === 'Personal').map((account) => {
        return account.name.trim()
      })
    }
  },

  watch: {
    'accountForm.name': {
      handler (value) {
        if (this.isNameExist(value.trim())) {
          this.errors.add({
            field: 'nameExist',
            msg: 'The account name must be unique.'
          })
        } else {
          this.errors.remove('nameExist')
        }
      },
      deep: true
    }
  },
  methods: {
    isNameExist (accountName) {
      return this.personalAccountNames.includes(accountName)
    },
    clearAccountForm () {
      this.showPopup = false
      this.$validator.reset()
      this.accountForm = {
        typeObj: null,
        name: '',
        company_name: '',
        country: null
      }
    },
    async createAccount () {
      await this.$validator.validate()

      if (this.errors.any()) return

      try {
        this.accountForm.type = this.accountForm.typeObj.value
        this.accountForm.country_id = this.accountForm.country.id
        delete this.accountForm.country
        delete this.accountForm.typeObj


        await this.$store.dispatch('authentication/createAccount', this.accountForm)
        this.clearAccountForm()


        this.successPrompt = true
      } catch (error) {
        this.$setLaravelValidationErrorsFromResponse(error.response.data)
      }
    },
    hidePopup () {
      this.successPrompt = false
      window.location.reload()
    },
    async getCountries () {
      const cache = this.$store.getters['settings/countries']
      if (!isEmpty(cache)) {
        this.countries = cache
      } else {
        await this.$store.dispatch('settings/getCountries')
        this.countries = this.$store.getters['settings/countries']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .create-new-account-parent {
    padding: 37px 37px 37px 42px;
  }

  .create-new-account-title {
    margin-bottom: 30px;
  }

  .account-name-label {
    font-size: 14px;
    color: #2c2c2c;
    margin-bottom: 11px;
    font-weight: normal;
  }

  .account-country-label,
  .account-type-label,
  .company-name-label {
    color: #2c2c2c;
    font-size: 14px;
    font-weight: normal;
  }

  .account-country-dropdown,
  .account-type-dropdown {
    margin-top: 8px;
  }

  .account-country-parent {
    margin-top: 32px;
    margin-bottom: 32px;
  }

  .company-name-parent {
    margin-top: 32px;
  }

  .account-name-desc {
    color: #999;
    font-weight: normal;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .account-name-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    height: 40px;
    text-indent: 10px;
  }

  .company-name-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    height: 40px;
    text-indent: 10px;
    margin-top: 8px;
  }

  .company-name-input::placeholder {
    color: rgba(0, 0, 0, 0.25);
  }

  /deep/ .vs__search {
    color: rgba(0, 0, 0, 0.25) !important;
  }

  .account-name-input::placeholder {
    color: rgba(0, 0, 0, 0.25);
  }

  .actions-parent {
    margin-top: 48px;
  }

  .add-new-account-add-button {
    width: 185px;
    height: 48px;
    border: none;
    box-shadow: none;
    color: white;
    border-radius: 3px;
    cursor: pointer;
    outline: none;
    background-color: #0092d7;
  }

  .add-new-account-cancel-button {
    width: 135px;
    height: 48px;
    border: 2px solid #d9d9d9;
    box-shadow: none;
    color: rgba(0, 0, 0, 0.65);
    border-radius: 3px;
    cursor: pointer;
    outline: none;
    background-color: white;
  }

  @media (max-width: 768px) {
    .add-new-account-cancel-button,
    .add-new-account-add-button {
      width: 100% !important;
    }

    .add-new-account-add-button {
      margin-bottom: 20px !important;
    }

    .create-new-account-parent {
      padding: 20px;
    }

    .actions-parent {
      display: flex;
      flex-direction: column-reverse;
    }
  }

</style>
